// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 48) return "static/css/48.446f8c36d1417c7c40f8.lib.css";
	if (chunkId === 764) return "static/css/764.f2dc14c9bc420bb6b30e.css";
	// return url for filenames based on template
	return undefined;
};